import React from 'react';
import { PMenuIconProps, useMenuIcon } from './useMenuIcon';

export const EmailTemplateIco: React.FC<PMenuIconProps> = (props) => {
  const { currentColor, classes } = useMenuIcon(props);
  return (
    <svg
      className={classes.ico}
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9992 20.0146C12.567 20.0146 10.2804 20.9618 8.56055 22.6817L1.24219 30H28.7563L21.4379 22.6816C19.7181 20.9618 17.4315 20.0146 14.9992 20.0146Z"
        fill={currentColor}
      />
      <path
        d="M0 15.3643V28.7573L6.6965 22.0608L0 15.3643Z"
        fill={currentColor}
      />
      <path
        d="M23.3027 22.0608L29.9992 28.7573V15.3643L23.3027 22.0608Z"
        fill={currentColor}
      />
      <path
        d="M27.0508 11.6865V15.8271L29.1211 13.7568L27.0508 11.6865Z"
        fill={currentColor}
      />
      <path
        d="M2.9492 11.6865L0.878906 13.7569L2.9492 15.8272V11.6865Z"
        fill={currentColor}
      />
      <path
        d="M15 18.2568C16.2095 18.2568 19.2442 18.4661 22.0357 20.8424L25.2929 17.5852V0.878906C25.2929 0.393516 24.8994 0 24.414 0H5.58594C5.10055 0 4.70703 0.393516 4.70703 0.878906V17.5852L7.96426 20.8424C10.7526 18.469 13.7839 18.2568 15 18.2568ZM10.3555 7.74873C10.3552 6.92871 11.39 6.56232 11.9071 7.18359H12.3825C12.5013 6.83068 12.6893 6.50959 12.9307 6.23631L12.6923 5.8234C12.4455 5.77969 12.219 5.63162 12.0839 5.39754C11.8412 4.97713 11.9853 4.43959 12.4057 4.19695L12.9494 3.88318C13.3696 3.64055 13.9072 3.78463 14.1499 4.2051C14.2849 4.43895 14.2998 4.70889 14.2145 4.94426L14.4519 5.35547C14.8041 5.28275 15.1957 5.28275 15.5479 5.35547L15.785 4.94473C15.6995 4.70918 15.7144 4.439 15.8495 4.20504C16.092 3.78457 16.6296 3.64049 17.05 3.88313L17.5936 4.19695C18.014 4.43959 18.1582 4.97713 17.9155 5.39754C17.7805 5.63144 17.5541 5.77945 17.3076 5.82328L17.0691 6.23625C17.3105 6.50947 17.4986 6.83063 17.6174 7.18354H18.0928C18.6102 6.56197 19.6448 6.92906 19.6444 7.74867V8.37627C19.6447 9.19635 18.6098 9.56268 18.0928 8.94135H17.6174C17.4986 9.29426 17.3105 9.61541 17.0691 9.88863L17.3075 10.3015C17.5541 10.3454 17.7805 10.4934 17.9155 10.7273C18.1582 11.1478 18.0141 11.6853 17.5937 11.9279L17.05 12.2417C16.5907 12.5068 16.0674 12.2974 15.8495 11.9198C15.7144 11.6858 15.6995 11.4156 15.785 11.1801L15.5479 10.7694C15.1957 10.8421 14.8042 10.8421 14.4519 10.7694L14.2145 11.1806C14.2999 11.416 14.2849 11.6859 14.1499 11.9198C13.9434 12.2775 13.4295 12.5188 12.9493 12.2417L12.4057 11.9279C11.9853 11.6853 11.8412 11.1478 12.0839 10.7273C12.219 10.4933 12.4456 10.3452 12.6924 10.3015L12.9307 9.88863C12.6893 9.61541 12.5012 9.29426 12.3824 8.94135H11.907C11.3896 9.56297 10.3549 9.19588 10.3554 8.37627L10.3555 7.74873ZM10.293 14.5918H19.7071C20.8732 14.6382 20.8723 16.3036 19.7071 16.3496H10.293C9.12682 16.3031 9.12775 14.6378 10.293 14.5918Z"
        fill={currentColor}
      />
      <path
        d="M15 9.06614C15.5536 9.06614 16.004 8.61579 16.004 8.0622C15.9488 6.73036 14.0511 6.73077 13.9961 8.0622C13.9961 8.61579 14.4464 9.06614 15 9.06614Z"
        fill={currentColor}
      />
    </svg>
  );
};
